import _sfc_main from "./component-library118.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _setup.src && _vm.renderWithoutFigure ? _c(_setup.ImageElement, _vm._b({ attrs: { "alt": _setup.computedAlt, "src": _setup.src, "lazy": _vm.lazy }, on: { "image-error": function($event) {
    return _vm.$emit("image-error", $event);
  } } }, "ImageElement", _setup.passThroughProps, false)) : _setup.src ? _c(_setup.PictureElement, _vm._b({ attrs: { "alt": _setup.computedAlt, "src": _setup.src, "src-sm": _setup.srcSm, "lazy": _vm.lazy }, on: { "image-error": function($event) {
    return _vm.$emit("image-error", $event);
  } } }, "PictureElement", _setup.passThroughProps, false)) : _vm._e();
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const GoliathImageElement = __component__.exports;
export {
  GoliathImageElement as default
};
